
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/returns/[slug]",
      function () {
        return require("private-next-pages/returns/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/returns/[slug]"])
      });
    }
  